"use client";

import { HStack, Skeleton, VStack } from "@chakra-ui/react";
import type { BillingPeriod } from "../data/pricingData";

interface Props {
  billing: BillingPeriod;
  variant: "card" | "table";
}

export function CatalogPriceSkeleton({ billing, variant }: Props) {
  const align = variant === "table" ? "center" : "start";
  const showAnnualSubline = billing === "annual" && variant === "table";

  return (
    <VStack
      gap={showAnnualSubline ? 1 : 0}
      align={align}
      w={variant === "card" ? "full" : undefined}
    >
      <HStack gap={2} align="baseline">
        <Skeleton height="36px" width="84px" borderRadius="md" />
        <Skeleton
          height={variant === "card" ? "24px" : "20px"}
          width="56px"
          borderRadius="md"
        />
      </HStack>
      {showAnnualSubline ? (
        <Skeleton height="14px" width="118px" borderRadius="md" />
      ) : null}
    </VStack>
  );
}
